import React, { FC } from "react"
import { Button, Flex, Stack, Text, Title } from "@mantine/core"
import { Link } from "react-router-dom"

const HTTP404: FC = () => (
    <Flex
        align="center"
        justify="center"
        p="md"
        sx={theme => ({
            height: "100svh",
            backgroundImage: theme.fn.gradient({
                from: theme.colors.green[8],
                to: theme.colors.blue[5],
                deg: 45,
            }),
        })}
    >
        <Stack spacing="4rem" align="center" w={600}>
            <Title size="20rem" sx={theme => ({ color: theme.fn.rgba(theme.colors.gray[9], 0.5) })}>
                404
            </Title>
            <Text size="xl" ta="center">
                Oh no! You found a page that doesnt exist. You may have mistyped the address, or the page has been moved
                to another URL.
            </Text>
            <Button size="xl" variant="white" component={Link} to="/">
                Go back home
            </Button>
        </Stack>
    </Flex>
)

export default HTTP404
